import axios from "axios";
import { getUserFromLS } from "../utils/getUserFromLS";
import {
  ICadenceTemplatePatch,
  ICadenceTemplateRead,
} from "../Types/socialPromptCadenceTemplate";

/** Patch an existing cadence template. When `steps` is sent it replaces the full list. */
export const updateSocialPromptCadenceTemplate = async (
  templateId: string,
  payload: ICadenceTemplatePatch
): Promise<ICadenceTemplateRead> => {
  const user = getUserFromLS();
  const URL = `${import.meta.env.VITE_API_BASE_URL}/social-prompt-cadence-templates/${encodeURIComponent(
    templateId
  )}`;

  const body: ICadenceTemplatePatch = {};
  if (payload.is_default !== undefined) body.is_default = payload.is_default;
  if (payload.title !== undefined) body.title = payload.title;
  if (payload.voice_key !== undefined) body.voice_key = payload.voice_key ?? null;
  if (payload.context !== undefined) body.context = payload.context ?? null;
  if (payload.steps !== undefined) {
    body.steps = payload.steps.map((step) => ({
      content_type: step.content_type,
      objective: step.objective ?? null,
    }));
  }

  const response = await axios.patch<ICadenceTemplateRead>(URL, body, {
    headers: {
      Authorization: `Bearer ${user.access_token}`,
    },
  });

  return response.data;
};
